__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/da886655a5864017a5cd14f5cb992588096340d2d1b99207cb576fdf/";